module.exports = __webpack_public_path__ + "static/background-hero-xl-7fce0fd19eb85959ce89d60bc7968848.png";